<div class="container-box">
  <app-loading-section *ngIf="isLoading"></app-loading-section>
  <div *ngIf="!isLoading">
    <!-- Header section -->
    <div class="d-flex justify-content-between align-items-center gap-3 p-3 border-bottom">
      <h4 class="m-0" i18n>Unit Gallery</h4>
      <div class="flex-fill"></div>
      <button
        class="btn btn-secondary-primary"
        (click)="onRefresh()"
        i18n-matTooltip
        matTooltip="Refresh List"
        matTooltipPosition="above"
      >
        <i class="far fa-sync"></i>
      </button>
      <div class="btn-group dropdown" role="group" dropdown [isDisabled]="1 | isReadonlyRole">
        <button
          dropdownToggle
          type="button"
          class="btn btn-secondary-warning dropdown-toggle"
          i18n-matTooltip
          matTooltip="You can perform multiple actions using this button"
        >
          <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
          <li>
            <button (click)="onBatchDelete()" type="button" [disabled]="!photoGrid?.selectedPhotos?.size">
              <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete from Gallery</ng-container>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="p-3">
      <!-- Gallery Photos -->
      <ng-container *ngIf="galleryData?.order?.length > 0">
        <app-photo-grid
          #photoGrid
          [propertyId]="propertyId"
          [roomId]="roomId"
          [photos]="photos"
          [showSelection]="true"
          [showDelete]="true"
          (delete)="onDeletePhoto($event)"
        ></app-photo-grid>
      </ng-container>

      <app-empty-table *ngIf="!isLoading && galleryData.order.length === 0">
        <img class="empty-image" src="assets/images/empty_icons/bdc-photo.svg" />
        <h5 class="empty-header" i18n>Showcase Your Unit Beautifully</h5>
        <p i18n>Add stunning images to highlight each unit’s unique features and attract more bookings.</p>
      </app-empty-table>
    </div>
  </div>
</div>
